import { organisationRoles } from "../constants/role";

const isOwnerOfOrganisation = (membership) => {
    return membership?.organisation?.role === organisationRoles.OWNER;
};

export default isOwnerOfOrganisation